import axios from "axios";
import { apiHeaders } from "../../helper/apiHeader";
import { getStudentData } from "../../helper/localStorage";
import { message } from "antd";
import { getSurveyQue } from "./getSurveyQue";

export const addSurveyResult = (surveyId, answer, dispatchSurvey, history) => {
  const myData = {
    data: {
      player_id: getStudentData().login_id,
      survey_id: surveyId,
      res: answer,
    },
  };

  dispatchSurvey({ type: "SURVEY_LOADER" });

  axios
    .post("/UserProfile", myData, apiHeaders("addsurveyresult"))
    .then((res) => {
      if (res.data.status === "201") {
        dispatchSurvey({ type: "SURVEY_RESULT_ADDED" });
        history.push(`/survey/${surveyId}`);

        // 18 june 2021
        window.location.reload(true);
      } else {
        message.error(res.data.msg);
        dispatchSurvey({ type: "SURVEY_ERR" });
      }
    })
    .catch(() => {
      message.error(
        "Please wait for sometime or check your internet connection. Try again"
      );
      dispatchSurvey({ type: "SURVEY_ERR" });
    });
};
